import { render } from "./SearchGrade.vue?vue&type=template&id=6478c4f7&scoped=true&ts=true"
import script from "./SearchGrade.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchGrade.vue?vue&type=script&setup=true&lang=ts"

import "./SearchGrade.vue?vue&type=style&index=0&id=6478c4f7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6478c4f7"],['__file',"src/components/sgre/SearchGrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6478c4f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6478c4f7', __exports__)) {
    console.log('reload')
    api.reload('6478c4f7', __exports__)
  }
  
  module.hot.accept("./SearchGrade.vue?vue&type=template&id=6478c4f7&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6478c4f7', render)
  })

}


export default __exports__